import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccredibleListItemComponent } from './list-item.component';

@NgModule({
  imports: [CommonModule],
  declarations: [AccredibleListItemComponent],
  exports: [AccredibleListItemComponent],
})
export class AccredibleListItemComponentModule {}
